import { FileUpload } from '@mui/icons-material'
import { Box, Tooltip } from '@mui/material'
import { actionIconStyle } from 'components/ActionUtil'
import PropTypes from 'prop-types'
import React from 'react'

const ImportFile = ({
    onClick = () => { },
    format = '',
    tooltip = '',
}) => {
    return (
        <Tooltip id={'import_file_action_navbar'} title={tooltip}>
            <Box px={2}>
                <label>
                    <input
                        type='file'
                        value=''
                        accept={format}
                        onChange={onClick}
                        style={{ display: 'None' }}
                    />
                    <FileUpload sx={{ ...actionIconStyle, color: 'white' }} />
                </label>
            </Box>
        </Tooltip>
    )
}

ImportFile.propTypes = {
    onClick: PropTypes.func,
    format: PropTypes.string,
    tooltip: PropTypes.string,
}

export default ImportFile